import type { ComparisonFiltersState, ComparisonOfferInput } from './ComparisonTypes'

/**
 * ComparisonFilters — channel / stock / duplicate / query filters.
 */
export class ComparisonFilters {
  applyOffers(
    offers: ComparisonOfferInput[],
    filters: ComparisonFiltersState,
  ): ComparisonOfferInput[] {
    return offers.filter((offer) => {
      if (filters.distributorsOnly && offer.channel !== 'distributor') return false
      if (filters.webOnly && offer.channel !== 'web') return false
      if (filters.paraguayOnly && offer.channel !== 'paraguay') return false

      if (filters.inStockOnly && offer.stock <= 0 && offer.channel !== 'paraguay') return false
      if (!filters.showOutOfStock && offer.stock <= 0 && offer.channel !== 'paraguay') return false

      if (filters.query.trim()) {
        const q = filters.query.trim().toLowerCase()
        const hay = [
          offer.product.brand,
          offer.product.model,
          offer.product.category,
          offer.product.line,
          offer.product.partNumber,
          offer.product.fingerprint,
          offer.supplierName,
          offer.product.aliases.join(' '),
        ]
          .join(' ')
          .toLowerCase()
        if (!hay.includes(q)) return false
      }

      return true
    })
  }

  /**
   * When hideDuplicates is on, keep cheapest offer per supplier inside a fingerprint group.
   */
  dedupeBySupplier(offers: ComparisonOfferInput[]): ComparisonOfferInput[] {
    const map = new Map<string, ComparisonOfferInput>()
    for (const offer of offers) {
      const key = `${offer.fingerprint}::${offer.supplierId}`
      const current = map.get(key)
      if (!current || offer.price < current.price) map.set(key, offer)
    }
    return [...map.values()]
  }
}

export const comparisonFilters = new ComparisonFilters()
